"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderImageGrid = void 0;
var DetailPopTabType_1 = require("@/pages/detail/states/DetailPopTabType");
var React = require("react");
exports.renderImageGrid = function (props, type) {
    var root = type === DetailPopTabType_1.DetailPopTabType.PHOTO
        ? props.galleryPhotos
        : props.galleryFloorPlans;
    var renderImage = function (photo, defaultAltText, i) {
        var onImageClick = function () { return props.onGridImageClick(root.id, i, photo); };
        var renderSlideCaption = function (text) { return (React.createElement("div", { className: "c-imggrid__caption" },
            React.createElement("div", { className: "c-imggrid__caption-text" }, text))); };
        return (React.createElement("div", { onClick: onImageClick, key: i, className: "c-imggrid__image" },
            React.createElement("a", { target: "_blank", href: photo.jpg ? photo.jpg : photo.src },
                React.createElement("img", { src: photo.src, alt: photo.caption || '' })),
            photo.caption ? renderSlideCaption(photo.caption) : null));
    };
    var text = type === DetailPopTabType_1.DetailPopTabType.PHOTO ? props.t.photo : props.t.floorPlan;
    return (React.createElement("div", { className: "c-imggrid" },
        React.createElement("div", { className: "c-imggrid__title" }, text),
        React.createElement("div", { className: "c-imggrid__body" },
            type === DetailPopTabType_1.DetailPopTabType.FLOORPLAN ? (React.createElement("div", { className: "c-imggrid__disclaimer" }, props.t.floorPlanDisclaimer)) : null,
            React.createElement("div", { className: "c-imggrid__images" }, root.items.map(function (it, i) { return renderImage(it, props.defaultAltText, i); })))));
};
